import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './originTypeForm';
import List from './originTypeList';

const settings = {
    pathRegister: paths.originTypeRegister,
    pathList: paths.originType,
    apiPath: 'origin-type',
    permissionAdmin: null,
    title: 'Tipo de origem',
    entity: 'originType',
};

const OriginType: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const OriginTypeList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { OriginType, OriginTypeList };
